// extracted by mini-css-extract-plugin
module.exports = {"preview":"CertificatePreview_preview_3JsKU"};